import {createAction} from '@reduxjs/toolkit';
import {withPayloadType} from '../../react/util/redux';

export const handleError = createAction(
  'errors/handleError',
  withPayloadType<Error>(),
);

export type Actions = ReturnType<typeof handleError>;
